export enum Types {
  Initial = 'INITIALIZE',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  Register = 'REGISTER',
  Reset = 'RESET_PASSWORD',
  VerifyToken = 'VERIFY_TOKEN',
  AuthorizationReady = 'AUTHORIZATION_READY',
}
